import { COOKIE, getCookie } from "../../../services/cookie";

export const userName = () => { return unescape(getCookie(COOKIE.NAME)); }
export const farmName = () => { return getCookie(COOKIE.FARM); }